import React from "react";

// Videra chevron mark — a downward "V" cut from a governance gate stack.
export const VideraMark = ({ size = 22, className = "", color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    <path d="M3 4h7l6 15.5L22 4h7L19.5 28h-7L3 4Z" fill={color} />
    <rect x="3" y="0" width="26" height="2.5" fill={color} opacity="0.45" />
  </svg>
);

export const VideraLogo = ({ className = "", size = 20, color = "currentColor" }) => (
  <span className={`inline-flex items-center gap-2 ${className}`} data-testid="videra-logo">
    <VideraMark size={size} color={color} />
    <span className="font-black tracking-tight">Videra</span>
  </span>
);
